"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var clsx_1 = __importDefault(require("clsx"));
var StyledSvgWrapper_1 = __importDefault(require("./utils/StyledSvgWrapper"));
var SvgIcon = function (props) {
    var size = props.size, color = props.color, classNameProp = props.className, forwardedRef = props.forwardedRef, IconComp = props.IconComp, rest = __rest(props, ["size", "color", "className", "forwardedRef", "IconComp"]);
    var sizeMap = {
        s: '_ndsIcon--small',
        m: '_ndsIcon--medium',
        l: '_ndsIcon--large'
    };
    return (react_1.default.createElement(StyledSvgWrapper_1.default, __assign({ className: clsx_1.default(sizeMap[size], classNameProp, IconComp.name), ref: forwardedRef, fill: "none" }, rest),
        react_1.default.createElement(IconComp, { color: color })));
};
exports.IconRootComp = SvgIcon;
SvgIcon.propTypes = {
    size: prop_types_1.default.oneOf(['s', 'm', 'l']),
    color: prop_types_1.default.oneOfType([prop_types_1.default.string]),
    className: prop_types_1.default.string,
    forwardedRef: prop_types_1.default.any,
    IconComp: prop_types_1.default.func
};
SvgIcon.defaultProps = {
    size: 'm',
    color: undefined,
    className: undefined,
    forwardedRef: null,
    IconComp: null
};
exports.default = SvgIcon;
//# sourceMappingURL=SvgIcon.js.map